<template>
  <section class="invoice-add-wrapper">
    <b-row class="invoice-add mb-1">
      <b-col cols="12" md="5" xl="4">
        <b-form-checkbox
          v-model="reportSearchSection"
          @change="
            () => (this.showReportSearchSection = !this.showReportSearchSection)
          "
          ><b>show filters</b></b-form-checkbox
        >
      </b-col>
    </b-row>
    <b-row class="invoice-add">
      <!-- Col: Left (Invoice Container) -->

      <b-col
        v-if="reportSearchSection"
        cols="12"
        md="5"
        xl="4"
        class="invoice-actions left-pane-resizable"
        :style="leftPaneStyle"
      >
        <!-- Action Buttons -->

        <b-card>
          <!-- <b-tabs justified>
            <b-tab @click="onTabChange" title="Single"> -->
          <b-form-group label="Report Type">
            <b-form-radio-group
              @change="onReportChange"
              id="radio-group-3"
              v-model="filters.reportType"
              name="radio-sub"
            >
              <b-form-radio name="some-radios1" value="default"
                >Default Report</b-form-radio
              >
              <b-form-radio name="some-radios1" value="territory"
                >Report With Territory
              </b-form-radio>
            </b-form-radio-group>
          </b-form-group>
          <b-form-group label="Show Report By" v-slot="{ ariaDescribedby }">
            <b-form-radio-group
              @change="onOrderChange"
              id="radio-group-2"
              v-model="filters.showReportBy"
              :aria-describedby="ariaDescribedby"
              name="radio-sub-component"
            >
              <b-form-radio
                :aria-describedby="ariaDescribedby"
                name="some-radios"
                value="vendor"
                >Licensor</b-form-radio
              >
              <b-form-radio
                :aria-describedby="ariaDescribedby"
                name="some-radios"
                value="movie"
                >Movie</b-form-radio
              >
            </b-form-radio-group>
          </b-form-group>
          <div v-if="filters.showReportBy == 'vendor'">
            <b-form-group label="Licensor">
              <v-select
                @input="getLicensorMovies('no')"
                v-model="filters.licensor"
                placeholder="Licensor"
                label="company"
                :options="optionVendors"
                :loading="isVendorLoading"
                class="borderRadius-10"
              />
            </b-form-group>
            <b-form-group label="Movie">
              <v-select
                @input="onChange"
                v-model="filters.movie"
                placeholder="Movie"
                label="multi_movies"
                :options="optionMultipleMovies"
                :loading="isMovieLoading"
                class="borderRadius-10"
              />
            </b-form-group>
          </div>
          <div v-else>
            <b-form-group label="Movie">
              <v-select
                @input="getMoviesLicensor"
                v-model="filters.movie"
                placeholder="Movie"
                label="full_title"
                :options="optionMovies"
                :loading="isMovieLoading"
                class="borderRadius-10"
              />
            </b-form-group>
            <b-form-group label="Licensor">
              <v-select
                @input="onChange"
                v-model="filters.licensor"
                placeholder="Licensor"
                label="company"
                :options="optionCustomer"
                :loading="isVendorLoading"
                class="borderRadius-10"
              />
            </b-form-group>
          </div>

          <b-form-group v-if="tabIndex == 0" label="Revenue Date Range">
            <flat-pickr
              @input="onChange"
              v-model="filters.revenueDate"
              placeholder="Revenue Date"
              class="form-control borderRadius-10"
              :config="{ mode: 'range', ...$flatPickrConfig }"
            />
          </b-form-group>
          <b-form-group
            v-if="
              tabIndex == 0 &&
              currentContractData &&
              contractTerritoryTreeOptions.length
            "
            label="Territory"
          >
            <master-treeselect
              v-model="selectedTempTerritory"
              :allowSelectingDisabledDescendants="true"
              :options="contractTerritoryTreeOptions"
              multiple
              placeholder="Territory"
              class="borderRadius-10"
            />
          </b-form-group>

          <b-button
            v-if="tabIndex == 0"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="primary"
            class="mb-75 borderRadius-10"
            block
            @click="getReportContracts"
            :disabled="
              (filters.licensor || filters.movie) &&
              filters.revenueDate &&
              filters.revenueDate.split('to').length == 2
                ? false
                : true
            "
          >
            Fetch Royalty Report
          </b-button>
          <b-button
            v-if="tabIndex == 0 && hasFetchedTerritoryReport"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            class="mb-75 borderRadius-10"
            block
            @click="onRefetchReport"
            :disabled="!canRefetchTerritoryReport"
          >
            Refetch Report
          </b-button>
          <!-- </b-tab>
            <b-tab @click="onTabChange" title="Multiple" lazy>
              <b-form-group label="Licensor">
                <v-select
                  @input="getLicensorMovies('yes')"
                  v-model="selectedCustomer"
                  placeholder="Licensor"
                  label="company"
                  :options="optionVendors"
                />
              </b-form-group>
              <b-form-group label="Movie">
                <v-select
                  v-model="selectedMovie"
                  placeholder="Movie"
                  label="multi_movies"
                  :options="optionMultipleMovies"
                />
              </b-form-group>

              <b-form-group label="Revenue Date Range">
                <flat-pickr
                  v-model="revenueDateRange"
                  placeholder="Revenue Date"
                  class="form-control"
                  :config="{ mode: 'range', ...$flatPickrConfig }"
                />
              </b-form-group>
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="primary"
                class="mb-75"
                block
                @click="getReportContracts"
                :disabled="
                  !selectedCustomer ||
                  !selectedMovie ||
                  !revenueDateRange ||
                  revenueDateRange.split('to').length < 2
                    ? true
                    : false
                    ? true
                    : false
                "
              >
                Generate Report
              </b-button>
            </b-tab>
          </b-tabs> -->

          <b-button
            v-if="tabIndex == 2 || tabIndex == 1"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="primary"
            class="mb-75 borderRadius-10 buttonColor"
            block
            @click="searchSavedReports"
          >
            Search
          </b-button>

          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="reset"
            variant="outline-secondary"
            block
            @click="resetForm"
            class="borderRadius-10"
          >
            Reset
          </b-button>

          <!-- Button: Print -->
        </b-card>
        <table
          style="background: whiteSmoke"
          v-if="royaltyReportData && tabIndex == 0"
        >
          <tr>
            <td class="text-wrap text-left">
              Deduction P&A From Cinematic Gross Receipts (Cost Off Top Deal)
            </td>
            <td>
              {{ royaltyReportData.deductionPaFromCinemeticGrossReceipts }}
            </td>
          </tr>
          <tr>
            <td class="text-wrap text-left">
              Deduction MG From Cinematic Gross Receipts
            </td>
            <td>
              {{ royaltyReportData.deductionMgFromCinematicGrossReceipts }}
            </td>
          </tr>
          <tr>
            <td class="text-wrap text-left">
              Distributor Corridor Prior To Recoupement Of P&A
            </td>
            <td>
              {{ royaltyReportData.distributorCorridorPriorToRecoupementOfPa }}
            </td>
          </tr>
          <tr>
            <td class="text-wrap text-left">
              Distributor Corridor Prior To Recoupement of MG
            </td>
            <td>
              {{ royaltyReportData.distributorCorridorPriorToRecoupementOfMg }}
            </td>
          </tr>
          <tr>
            <td class="text-wrap text-left">
              Distributor Corridor Prior To Recoupement Of P&A and MG
            </td>
            <td>
              {{
                royaltyReportData.distributorCorridorPriorToRecoupementOfPaAndMg
              }}
            </td>
          </tr>
          <tr>
            <td class="text-wrap text-left">
              Licensor Corridor Prior To Recoupement Of P&A
            </td>
            <td>
              {{ royaltyReportData.licensorCorridorPriorToRecoupementOfPa }}
            </td>
          </tr>
          <tr>
            <td class="text-wrap text-left">
              Licensor Corridor Prior To Recoupement Of MG
            </td>
            <td>
              {{ royaltyReportData.licensorCorridorPriorToRecoupementOfMg }}
            </td>
          </tr>
        </table>
        <div
          v-if="showPaneResizer"
          class="pane-resizer pane-resizer-inline"
          @mousedown="startPaneResize"
        ></div>
      </b-col>
      <b-col
        cols="12"
        :xl="reportSearchSection ? '8' : '12'"
        :md="reportSearchSection ? '7' : '12'"
        :style="rightPaneStyle"
      >
        <div>
          <b-tabs pills v-model="tabIndex">
            <hr class="m-1" />
            <b-tab title="Royalty Report" active>
              <b-row>
                <b-col cols="12" md="9">
                  <div style="overflow-x: auto; white-space: nowrap">
                    <div v-if="selectedRotaltyContracts.length">
                      <span>Selected Reports</span>

                      <b-badge variant="light-primary" @click="onGenrateAll"
                        >generate for all selected</b-badge
                      >
                    </div>
                  </div>
                </b-col>
                <!-- <b-list-group horizontal>
                    <b-list-group-item
                      v-for="(item, index) in selectedRotaltyContracts"
                      :key="index"
                      :active="
                        selectedContractID == item.contract_id ? true : false
                      "
                      @click="getRoyaltyReportMultiple(item)"
                      >Report {{ index + 1 }}</b-list-group-item
                    >
                  </b-list-group> -->

                <!-- <b-col cols="12" md="9">
                  <b-form-group
                  v-if="selectedRotaltyContracts.length > 1"
                  label="Royalty Reports"
                  label-for="royalty-report-select"
                >
                  <v-select
                    id="royalty-report-select"
                    :options="reportOptions"
                    label="label"
                    :reduce="option => option.value"
                    v-model="selectedContractID"
                    @input="handleReportSelect"
                    placeholder="Select Royalty Reports"
                  />
                </b-form-group>
                </b-col> -->
                <b-col cols="12" md="9">
                  <b-form-group
                    v-if="selectedRotaltyContracts.length > 1"
                    label="Royalty Reports"
                    label-for="royalty-report-select"
                  >
                    <v-select
                      v-if="selectedRotaltyContracts.length > 1"
                      id="royalty-report-select"
                      :options="selectedRotaltyContracts"
                      :label="getOptionLabel"
                      :reduce="(item) => item.contract_id"
                      v-model="selectedContractID"
                      @input="handleReportSelect"
                      placeholder="Select Report"
                      class="borderRadius-10"
                    >
                      <template #option="option">
                        <div style="font-size: 12px; font-family: Verdana">
                          <strong
                            >Report
                            {{ getReportIndex(option.contract_id) }}</strong
                          ><br />
                          Contract Id: {{ option.contract_id }}<br />
                          Movie Title: {{ formattedTitle(option.title) }}
                        </div>
                      </template>
                      <template #selected-option="option">
                        <div style="font-size: 12px; font-family: Verdana">
                          <strong
                            >Report
                            {{ getReportIndex(option.contract_id) }}</strong
                          ><br />
                          Contract Id: {{ option.contract_id }}<br />
                          Movie Title: {{ formattedTitle(option.title) }}
                        </div>
                      </template>
                    </v-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="ml-1">
                <b-button
                  variant="primary"
                  class="my-1"
                  v-if="reportContractId"
                  @click="showRevenueExpensesModal = true"
                >
                  Show Revenue/Expenses
                </b-button>
              </b-row>
              <b-alert
                class="mt-1"
                v-if="royaltyReportData"
                variant="dark"
                show
              >
                <h4 class="alert-heading">
                  <span>
                    <b
                      >Licensor :
                      {{ filters.licensor ? filters.licensor.company : "" }}<br
                    /></b>
                    <b
                      >Movie :
                      {{ royaltyReportData.totalColumn.isMultipleMovies }}<br
                    /></b>

                    <b
                      >Territories :
                      {{ royaltyReportData.totalColumn.contractTerritories
                      }}<br
                    /></b>

                    <b
                      >Statement Period :
                      {{ royaltyReportData.totalColumn.reportDateRange }}</b
                    >
                  </span>
                </h4>
              </b-alert>
              <b-alert variant="dark" show>
                <h4 class="alert-heading">
                  For royalty report please provide required fields and click
                  generate report.
                </h4>
              </b-alert>

              <div v-if="royaltyReportData">
                <b-row>
                  <b-col md="6">
                    <b-form-group label="sent to">
                      <b-form-input
                        id="event-description"
                        v-model="reportSentTo"
                        class="borderRadius-10"
                      >
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                      label="Comments"
                      label-for="event-description"
                    >
                      <b-form-textarea
                        id="event-description"
                        v-model="reportDescription"
                        class="borderRadius-10"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>

                <div style="overflow-x: auto">
                  <table
                    class="report-table"
                    ref="rrt_table"
                    id="rrt_table"
                    v-if="royaltyReportData"
                  >
                    <colgroup>
                      <col class="col-label-main" />
                      <col class="col-territory" />
                      <col class="col-movie-unique" />
                      <col class="col-num" />
                      <col class="col-num" />
                      <col class="col-num" />
                      <col class="col-num" />
                    </colgroup>
                    <thead class="bg-gray-200">
                      <tr>
                        <th
                          class="px-1 text-left text-xs font-bold tracking-wider"
                          style="width: 300px"
                        >
                          Theatrical
                        </th>
                        <th
                          class="px-1 text-right text-xs font-bold tracking-wider"
                        >
                          Territories
                        </th>
                        <th
                          class="px-1 text-right text-xs font-bold tracking-wider"
                        >
                          Movie Unique
                        </th>
                        <th
                          class="px-1 text-right text-xs font-bold tracking-wider"
                        >
                          Admissions
                        </th>
                        <th
                          class="px-1 text-right text-xs font-bold tracking-wider"
                        >
                          Box Office
                        </th>
                        <th
                          class="px-1 text-right text-xs font-bold tracking-wider"
                        >
                          Rental
                        </th>
                        <th
                          class="px-1 text-right text-xs font-bold tracking-wider"
                        >
                          Total
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(
                          main, indexmain
                        ) in royaltyReportData.rentalSection"
                        :key="indexmain"
                        :class="{
                          'font-bold': indexmain === 1 || indexmain === 2,
                        }"
                      >
                        <td
                          colspan="1"
                          style="width: 100px"
                          class="px-1 whitespace-nowrap text-left"
                        >
                          {{
                            indexmain == 0
                              ? "Accumulated"
                              : indexmain == 1
                              ? "This Period"
                              : "Total"
                          }}
                        </td>
                        <td
                          class="px-1 whitespace-nowrap text-right force-wrap"
                        >
                          <span
                            v-for="(terr, terrIndex) in optionTempTerritory"
                            :key="terrIndex"
                          >
                            {{ terr.ter }}
                            <br
                          /></span>
                        </td>
                        <td
                          class="px-1 whitespace-nowrap text-right force-wrap"
                        >
                          <span
                            v-for="rowIndex in getColumnRowCount(
                              main,
                              'admission',
                            )"
                            :key="'movie-unique-rental-' + rowIndex"
                          >
                            {{ getMovieUniqueNoByRow(rowIndex - 1) }}
                            <br />
                          </span>
                        </td>
                        <td
                          v-for="(child, indexchild) in main"
                          :key="indexchild"
                          class="px-1 whitespace-nowrap text-right"
                        >
                          <span
                            v-for="(subChild, indexsubchild) in child"
                            :key="indexsubchild"
                          >
                            <div class="text-nowrap">
                              <span v-if="indexchild == 'admission'">
                                {{ subChild.totalValue }}</span
                              >
                              <span v-else>
                                <!-- {{ royaltyReportData.totalColumn.currency }} -->
                                {{ formatCurrency(subChild.totalValue) }}</span
                              >
                            </div>
                          </span>
                        </td>
                      </tr>

                      <tr class="font-bold bg-gray-200">
                        <td
                          class="px-1 whitespace-nowrap text-left"
                          colspan="6"
                        >
                          Total Rental
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          <div class="text-nowrap">
                            <span>
                              <!-- {{ royaltyReportData.totalColumn.currency }} -->
                              {{
                                formatCurrency(
                                  royaltyReportData.totalColumn.rentalTotalSum,
                                )
                              }}</span
                            >
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tr>
                      <th class="px-1 py-1" colspan="7"></th>
                    </tr>
                    <tbody>
                      <tr class="pna-subheader">
                        <td
                          class="px-1 whitespace-nowrap text-left"
                          colspan="2"
                        >
                          P&A
                        </td>
                        <td
                          colspan="2"
                          class="px-1"
                        >
                        </td>
                        <td
                          class="px-1 whitespace-nowrap text-right force-wrap"
                        >
                          Accumulated
                        </td>
                        <td
                          class="px-1 whitespace-nowrap text-right force-wrap"
                        >
                          This Period
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">Total</td>
                      </tr>
                      <tr class="pna-values">
                        <td class="px-1" colspan="2"></td>
                        <td
                          colspan="2"
                          class="px-1 whitespace-nowrap text-right force-wrap"
                        >
                          <span
                            v-for="(terr, terrIndex) in optionTempTerritory"
                            :key="terrIndex"
                          >
                            {{ terr.ter }}
                            <small
                              v-if="reportMovieUniqueNo"
                              class="territory-unique-no"
                            >
                              | {{ reportMovieUniqueNo }}
                            </small>
                            <br
                          /></span>
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          <span
                            v-for="(terr, terrIndex) in optionTempTerritory"
                            :key="'pna-acc-' + terrIndex"
                          >
                            {{ formatCurrency(0) }}
                            <br />
                          </span>
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          <span
                            v-for="(
                              main, indexmain
                            ) in royaltyReportData.pnaSection"
                            :key="indexmain"
                          >
                            <div class="text-nowrap">
                              <span>
                                <!-- {{ royaltyReportData.totalColumn.currency }} -->
                                {{ formatCurrency(main.totalValue) }}</span
                              >
                            </div></span
                          >
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          <span>
                            <!-- {{ royaltyReportData.totalColumn.currency }} -->
                            {{
                              formatCurrency(
                                royaltyReportData.totalColumn.pnaTotalSum,
                              )
                            }}</span
                          >
                        </td>
                      </tr>
                      <tr>
                        <td
                          colspan="6"
                          class="px-1 whitespace-nowrap text-left"
                        >
                          MG
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          <span>
                            <!-- {{ royaltyReportData.totalColumn.currency }} -->
                            {{
                              formatCurrency(
                                royaltyReportData.totalColumn.mgPaTotal,
                              )
                            }}</span
                          >
                        </td>
                      </tr>

                      <tr
                        v-if="
                          Number(
                            royaltyReportData.totalColumn
                              .distributorCorridorPriorToRecoupementOfPaSectionTotal,
                          ) > 0
                        "
                      >
                        <td
                          colspan="4"
                          class="px-1 whitespace-nowrap text-left"
                        >
                          Distributor Corridor Prior To Recoupement Of P&A -
                          {{
                            royaltyReportData.distributorCorridorPriorToRecoupementOfPaPercent
                          }}%
                        </td>
                        <td
                          class="px-1 whitespace-nowrap text-right force-wrap"
                        >
                          <span
                            v-for="(terr, terrIndex) in optionTempTerritory"
                            :key="terrIndex"
                          >
                            {{ terr.ter }}
                            <small
                              v-if="reportMovieUniqueNo"
                              class="territory-unique-no"
                            >
                              | {{ reportMovieUniqueNo }}
                            </small>
                            <br
                          /></span>
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          <span
                            v-for="(
                              main, indexmain
                            ) in royaltyReportData.distributorCorridorPriorToRecoupementOfPaSection"
                            :key="indexmain"
                          >
                            <span>
                              <!-- {{ royaltyReportData.totalColumn.currency }} -->
                              {{ formatCurrency(main.totalValue) }} </span
                            ><br
                          /></span>
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          <span>
                            <!-- {{ royaltyReportData.totalColumn.currency }} -->
                            {{
                              formatCurrency(
                                royaltyReportData.totalColumn
                                  .distributorCorridorPriorToRecoupementOfPaSectionTotal,
                              )
                            }}</span
                          >
                        </td>
                      </tr>
                      <tr
                        v-if="
                          Number(
                            royaltyReportData.totalColumn
                              .distributorCorridorPriorToRecoupementOfMgTotal,
                          ) > 0
                        "
                      >
                        <td
                          colspan="6"
                          class="px-1 whitespace-nowrap text-left"
                        >
                          Distributor Corridor Prior To Recoupement Of MG -
                          {{
                            royaltyReportData.distributorCorridorPriorToRecoupementOfMgPercent
                          }}%
                        </td>

                        <td class="px-1 whitespace-nowrap text-right">
                          <span>
                            <!-- {{ royaltyReportData.totalColumn.currency }} -->
                            {{
                              formatCurrency(
                                royaltyReportData.totalColumn
                                  .distributorCorridorPriorToRecoupementOfMgTotal,
                              )
                            }}</span
                          >
                        </td>
                      </tr>
                      <tr
                        v-if="
                          Number(
                            royaltyReportData.totalColumn
                              .distributorCorridorPriorToRecoupementOfPaAndMgTotal,
                          ) > 0
                        "
                      >
                        <td
                          colspan="6"
                          class="px-1 whitespace-nowrap text-left"
                        >
                          Distributor Corridor Prior To Recoupement Of P&A And
                          MG -
                          {{
                            royaltyReportData.distributorCorridorPriorToRecoupementOfPaAndMgPercent
                          }}%
                        </td>

                        <td class="px-1 whitespace-nowrap text-right">
                          <span>
                            <!-- {{ royaltyReportData.totalColumn.currency }} -->
                            {{
                              formatCurrency(
                                royaltyReportData.totalColumn
                                  .distributorCorridorPriorToRecoupementOfPaAndMgTotal,
                              )
                            }}</span
                          >
                        </td>
                      </tr>
                      <tr
                        v-if="
                          Number(
                            royaltyReportData.totalColumn
                              .licensorCorridorPriorToRecoupementOfPaSectionTotal,
                          ) > 0
                        "
                      >
                        <td
                          colspan="4"
                          class="px-1 whitespace-nowrap text-left"
                        >
                          Licensor Corridor Prior To Recoupement Of P&A -
                          {{
                            royaltyReportData.licensorCorridorPriorToRecoupementOfPaPercent
                          }}%
                        </td>
                        <td
                          class="px-1 whitespace-nowrap text-right force-wrap"
                        >
                          <span
                            v-for="(terr, terrIndex) in optionTempTerritory"
                            :key="terrIndex"
                          >
                            {{ terr.ter }}
                            <small
                              v-if="reportMovieUniqueNo"
                              class="territory-unique-no"
                            >
                              | {{ reportMovieUniqueNo }}
                            </small>
                            <br
                          /></span>
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          <span
                            v-for="(
                              main, indexmain
                            ) in royaltyReportData.licensorCorridorPriorToRecoupementOfPaSection"
                            :key="indexmain"
                          >
                            <span>
                              <!-- {{ royaltyReportData.totalColumn.currency }} -->
                              {{ formatCurrency(main.totalValue) }} </span
                            ><br
                          /></span>
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          <span>
                            <!-- {{ royaltyReportData.totalColumn.currency }} -->
                            {{
                              formatCurrency(
                                royaltyReportData.totalColumn
                                  .licensorCorridorPriorToRecoupementOfPaSectionTotal,
                              )
                            }}</span
                          >
                        </td>
                      </tr>
                      <tr
                        v-if="
                          Number(
                            royaltyReportData.totalColumn
                              .licensorCorridorPriorToRecoupementOfMgTotal,
                          ) > 0
                        "
                      >
                        <td
                          colspan="6"
                          class="px-1 whitespace-nowrap text-left"
                        >
                          Licensor Corridor Prior To Recoupement Of MG -
                          {{
                            royaltyReportData.licensorCorridorPriorToRecoupementOfMgPercent
                          }}%
                        </td>

                        <td class="px-1 whitespace-nowrap text-right">
                          <span>
                            <!-- {{ royaltyReportData.totalColumn.currency }} -->
                            {{
                              formatCurrency(
                                royaltyReportData.totalColumn
                                  .licensorCorridorPriorToRecoupementOfMgTotal,
                              )
                            }}</span
                          >
                        </td>
                      </tr>
                      <tr>
                        <td
                          colspan="3"
                          class="px-1 whitespace-nowrap text-left"
                        >
                          Total Less
                        </td>
                        <td
                          colspan="2"
                          class="px-1 whitespace-nowrap text-right force-wrap"
                        >
                          <span
                            v-for="(terr, terrIndex) in optionTempTerritory"
                            :key="terrIndex"
                          >
                            {{ terr.ter }}
                            <small
                              v-if="reportMovieUniqueNo"
                              class="territory-unique-no"
                            >
                              | {{ reportMovieUniqueNo }}
                            </small>
                            <br
                          /></span>
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          <span
                            v-for="(
                              main, indexmain
                            ) in royaltyReportData.lessTotalSection"
                            :key="indexmain"
                          >
                            <span>
                              <!-- {{ royaltyReportData.totalColumn.currency }} -->
                              {{ formatCurrency(main.totalValue) }}</span
                            >
                            <br
                          /></span>
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          <span>
                            <!-- {{ royaltyReportData.totalColumn.currency }} -->
                            {{
                              formatCurrency(
                                royaltyReportData.totalColumn.lessSectionTotal,
                              )
                            }}</span
                          >
                        </td>
                      </tr>

                      <tr>
                        <td
                          colspan="3"
                          class="px-1 whitespace-nowrap text-left"
                        >
                          Cinematic Share Post Recoupment
                        </td>
                        <td
                          colspan="2"
                          class="px-1 whitespace-nowrap text-right force-wrap"
                        >
                          <span
                            v-for="(terr, terrIndex) in optionTempTerritory"
                            :key="terrIndex"
                          >
                            {{ terr.ter }}
                            <small
                              v-if="reportMovieUniqueNo"
                              class="territory-unique-no"
                            >
                              | {{ reportMovieUniqueNo }}
                            </small>
                            <br
                          /></span>
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          <span
                            v-for="(
                              main, indexmain
                            ) in royaltyReportData.cinemeticSharePostRecoupmentSection"
                            :key="indexmain"
                          >
                            <span>
                              <!-- {{ royaltyReportData.totalColumn.currency }} -->
                              {{ formatCurrency(main.totalValue) }} </span
                            ><br
                          /></span>
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          <span>
                            <!-- {{ royaltyReportData.totalColumn.currency }} -->
                            {{
                              formatCurrency(
                                royaltyReportData.totalColumn
                                  .cinemeticSharePostRecoupmentSectionTotal,
                              )
                            }}</span
                          >
                        </td>
                      </tr>
                      <tr>
                        <th colspan="7" class="px-1 py-1"></th>
                      </tr>

                      <tr class="font-bold bg-gray-200">
                        <td
                          colspan="3"
                          class="px-1 whitespace-nowrap text-left"
                        >
                          Licensor's Share Of Overage -
                          {{ royaltyReportData.licenorShareOfOveragePercent }} %
                        </td>
                        <td
                          colspan="2"
                          class="px-1 whitespace-nowrap text-right force-wrap"
                        >
                          <span
                            v-for="(terr, terrIndex) in optionTempTerritory"
                            :key="terrIndex"
                          >
                            {{ terr.ter }}
                            <small
                              v-if="reportMovieUniqueNo"
                              class="territory-unique-no"
                            >
                              | {{ reportMovieUniqueNo }}
                            </small>
                            <br
                          /></span>
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          <span
                            v-for="(
                              main, indexmain
                            ) in royaltyReportData.licenorShareOfOverageSection"
                            :key="indexmain"
                          >
                            <span>
                              <!-- {{ royaltyReportData.totalColumn.currency }} -->
                              {{ formatCurrency(main.totalValue) }} </span
                            ><br
                          /></span>
                        </td>
                        <td class="px-1 pb-1 whitespace-nowrap text-right">
                          <span>
                            <!-- {{ royaltyReportData.totalColumn.currency }} -->
                            {{
                              formatCurrency(
                                royaltyReportData.totalColumn
                                  .licenorShareOfOverageSectionTotal,
                              )
                            }}</span
                          >
                        </td>
                      </tr>
                    </tbody>

                    <tr>
                      <th colspan="7" class="px-1 py-1"></th>
                    </tr>

                    <tbody>
                      <tr
                        v-for="(
                          main, indexmain
                        ) in royaltyReportData.licensorShareData"
                        :key="indexmain"
                        :class="{
                          'bg-gray-200': main.key == 'header',
                        }"
                      >
                        <th
                          class="px-1 text-left text-xs font-bold"
                          colspan="2"
                          v-if="main.key == 'header'"
                        >
                          {{ main.movieName }}
                        </th>
                        <th
                          v-if="main.key == 'header'"
                          class="px-1 whitespace-nowrap text-right"
                        >
                          Accumulated
                        </th>
                        <th
                          v-if="main.key == 'header'"
                          class="px-1 whitespace-nowrap text-right"
                        >
                          This Period
                        </th>
                        <th
                          v-if="main.key == 'header'"
                          class="px-1 whitespace-nowrap text-right"
                        >
                          {{ main.total_revenue }}
                        </th>
                        <th
                          v-if="main.key == 'header'"
                          class="px-1 whitespace-nowrap text-right"
                        >
                          Share
                        </th>
                        <th
                          v-if="main.key == 'header'"
                          class="px-1 whitespace-nowrap text-right"
                        >
                          Licensor's Share
                        </th>

                        <!-- data from here -->
                        <td
                          class="px-1 whitespace-nowrap text-left"
                          colspan="2"
                          v-if="main.key == 'data'"
                        >
                          {{ main.movieName }}
                          <span
                            class="text-muted"
                            v-if="main.movieName != main.subrightsNamesString"
                            ><br /><small class="text-muted"
                              >({{ main.subrightsNamesString }})</small
                            ></span
                          >
                        </td>
                        <td
                          class="px-1 whitespace-nowrap text-right"
                          v-if="main.key == 'data'"
                        >
                          <span>
                            <!-- {{ royaltyReportData.totalColumn.currency }} -->
                            {{ formatCurrency(main.acc_revenue) }}</span
                          >
                        </td>
                        <td
                          class="px-1 whitespace-nowrap text-right"
                          v-if="main.key == 'data'"
                        >
                          <span>
                            <!-- {{ royaltyReportData.totalColumn.currency }} -->
                            {{ formatCurrency(main.period_revenue) }}</span
                          >
                        </td>
                        <td
                          class="px-1 whitespace-nowrap text-right"
                          v-if="main.key == 'data'"
                        >
                          <span>
                            <!-- {{ royaltyReportData.totalColumn.currency }} -->
                            {{ formatCurrency(main.total_revenue) }}</span
                          >
                        </td>
                        <td
                          class="px-1 whitespace-nowrap text-right"
                          v-if="main.key == 'data'"
                        >
                          {{ formatCurrency(main.share_percent) }}%
                        </td>
                        <td
                          class="px-1 whitespace-nowrap text-right"
                          v-if="main.key == 'data'"
                        >
                          <span>
                            <!-- {{ royaltyReportData.totalColumn.currency }} -->
                            {{
                              formatCurrency(main.amount_after_percent)
                            }}</span
                          >
                        </td>
                      </tr>
                      <tr class="font-bold">
                        <td
                          colspan="6"
                          class="px-1 whitespace-nowrap text-left"
                        >
                          Territories Total
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          <span>
                            <!-- {{ royaltyReportData.totalColumn.currency }} -->
                            {{
                              formatCurrency(
                                royaltyReportData.totalColumn.territorySumTotal,
                              )
                            }}</span
                          >
                        </td>
                      </tr>

                      <tr class="font-bold bg-gray-200">
                        <td
                          colspan="6"
                          class="px-1 whitespace-nowrap text-left"
                        >
                          Total Licensor Share
                        </td>
                        <td class="px-1 pb-1 whitespace-nowrap text-right">
                          <span>
                            <!-- {{ royaltyReportData.totalColumn.currency }} -->
                            {{
                              formatCurrency(
                                royaltyReportData.totalColumn.totalLicensorSum,
                              )
                            }}
                          </span>
                        </td>
                      </tr>

                      <tr>
                        <th class="px-1 py-1" colspan="7"></th>
                      </tr>

                      <tr class="font-bold bg-gray-200">
                        <td
                          colspan="6"
                          class="px-1 whitespace-nowrap text-left"
                        >
                          Total With Licensor Corridor Prior To Recoupment
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          <span>
                            <!-- {{ royaltyReportData.totalColumn.currency }} -->
                            {{
                              formatCurrency(
                                royaltyReportData.totalColumn.totalLicensorSum,
                              )
                            }}</span
                          >
                        </td>
                      </tr>

                      <tr>
                        <th class="px-1 py-1" colspan="7"></th>
                      </tr>

                      <tr v-if="royaltyReportData.showCoridorSection == true">
                        <th
                          colspan="7"
                          class="px-1 pt-1 whitespace-nowrap text-left"
                        >
                          Licensor Share of Corridor
                        </th>
                      </tr>
                      <tr v-if="royaltyReportData.showCoridorSection == true">
                        <td
                          colspan="6"
                          class="px-1 whitespace-nowrap text-left"
                        >
                          Licensor Share prior to recoupement on P&A
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          <span>
                            <!-- {{ royaltyReportData.totalColumn.currency }} -->
                            {{
                              formatCurrency(
                                royaltyReportData.totalColumn
                                  .licensorCorridorPriorToRecoupementOfPaSectionTotal,
                              )
                            }}</span
                          >
                        </td>
                      </tr>
                      <tr v-if="royaltyReportData.showCoridorSection == true">
                        <td
                          colspan="6"
                          class="px-1 whitespace-nowrap text-left"
                        >
                          Licensor Share prior to recoupement on MG
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          <span>
                            <!-- {{ royaltyReportData.totalColumn.currency }} -->
                            {{
                              formatCurrency(
                                royaltyReportData.totalColumn
                                  .licensorCorridorPriorToRecoupementOfMgTotal,
                              )
                            }}</span
                          >
                        </td>
                      </tr>
                      <tr v-if="royaltyReportData.showCoridorSection == true">
                        <td
                          colspan="6"
                          class="px-1 whitespace-nowrap text-left"
                        >
                          Total Licensor Corridor
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          <span>
                            <!-- {{ royaltyReportData.totalColumn.currency }} -->
                            {{
                              formatCurrency(
                                royaltyReportData.totalColumn
                                  .totalLicensorCoridor,
                              )
                            }}</span
                          >
                        </td>
                      </tr>

                      <tr v-if="royaltyReportData.showCoridorSection == true">
                        <td
                          colspan="4"
                          class="px-1 whitespace-nowrap text-left"
                        >
                          Less Licensor corridor Paid
                        </td>
                        <td
                          class="px-1 whitespace-nowrap text-right force-wrap"
                        >
                          <span
                            v-for="(terr, terrIndex) in optionTempTerritory"
                            :key="terrIndex"
                          >
                            {{ terr.ter }}
                            <small
                              v-if="reportMovieUniqueNo"
                              class="territory-unique-no"
                            >
                              | {{ reportMovieUniqueNo }}
                            </small>
                            <br
                          /></span>
                        </td>

                        <td class="px-1 whitespace-nowrap text-right">
                          <span
                            v-for="(
                              main, indexmain
                            ) in royaltyReportData.lessCoridorPaidSection"
                            :key="indexmain"
                          >
                            <span
                              ><!-- {{ royaltyReportData.totalColumn.currency }} -->
                              {{ formatCurrency(main.totalValue) }}</span
                            >
                            <br
                          /></span>
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          <span>
                            <!-- {{ royaltyReportData.totalColumn.currency }} -->
                            {{
                              formatCurrency(
                                royaltyReportData.totalColumn
                                  .lessLicensorCorridorPaid,
                              )
                            }}
                          </span>
                        </td>
                      </tr>

                      <tr
                        v-if="royaltyReportData.showCoridorSection == true"
                        class="font-bold"
                      >
                        <td
                          colspan="6"
                          class="px-1 whitespace-nowrap text-left"
                        >
                          Balance Payable
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          <span>
                            <!-- {{ royaltyReportData.totalColumn.currency }} -->
                            {{
                              formatCurrency(
                                royaltyReportData.totalColumn
                                  .balancePayableSecond,
                              )
                            }}</span
                          >
                        </td>
                      </tr>

                      <tr
                        v-if="royaltyReportData.showCoridorSection == true"
                        class="font-bold bg-gray-200"
                      >
                        <td
                          colspan="6"
                          class="px-1 whitespace-nowrap text-left"
                        >
                          Total Payable
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          <span>
                            <!-- {{ royaltyReportData.totalColumn.currency }} -->
                            {{
                              formatCurrency(
                                royaltyReportData.totalColumn.totalFinalPayable,
                              )
                            }}</span
                          >
                        </td>
                      </tr>
                      <tr>
                        <th class="px-1 py-1" colspan="7"></th>
                      </tr>
                      <tr class="font-bold">
                        <th
                          class="px-1 whitespace-nowrap text-left"
                          colspan="7"
                        >
                          Already Paid
                        </th>
                      </tr>
                      <tr>
                        <td
                          colspan="6"
                          class="px-1 whitespace-nowrap text-left"
                        >
                          MG
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          <span>
                            <!-- {{ royaltyReportData.totalColumn.currency }} -->
                            {{
                              formatCurrency(
                                royaltyReportData.totalColumn.lessPaidMgTotal,
                              )
                            }}</span
                          >
                        </td>
                      </tr>
                      <tr>
                        <td
                          colspan="3"
                          class="px-1 whitespace-nowrap text-left"
                        >
                          Bumper Paid
                        </td>
                        <td
                          colspan="2"
                          class="px-1 whitespace-nowrap text-right force-wrap"
                        >
                          <span
                            v-for="(terr, terrIndex) in optionTempTerritory"
                            :key="terrIndex"
                          >
                            {{ terr.ter }}
                            <small
                              v-if="reportMovieUniqueNo"
                              class="territory-unique-no"
                            >
                              | {{ reportMovieUniqueNo }}
                            </small>
                            <br
                          /></span>
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          <span
                            v-for="(
                              main, indexmain
                            ) in royaltyReportData.bumperSection"
                            :key="indexmain"
                          >
                            <span>
                              <!-- {{ royaltyReportData.totalColumn.currency }} -->
                              {{ formatCurrency(main.totalValue) }} </span
                            ><br
                          /></span>
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          <span>
                            <!-- {{ royaltyReportData.totalColumn.currency }} -->
                            {{
                              formatCurrency(
                                royaltyReportData.totalColumn
                                  .lessBumperPaidTotal,
                              )
                            }}</span
                          >
                        </td>
                      </tr>
                      <tr>
                        <td
                          colspan="3"
                          class="px-1 whitespace-nowrap text-left"
                        >
                          Overage Paid
                        </td>
                        <td
                          colspan="2"
                          class="px-1 whitespace-nowrap text-right force-wrap"
                        >
                          <span
                            v-for="(terr, terrIndex) in optionTempTerritory"
                            :key="terrIndex"
                          >
                            {{ terr.ter }}
                            <small
                              v-if="reportMovieUniqueNo"
                              class="territory-unique-no"
                            >
                              | {{ reportMovieUniqueNo }}
                            </small>
                            <br
                          /></span>
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          <span
                            v-for="(
                              main, indexmain
                            ) in royaltyReportData.overagePaidSection"
                            :key="indexmain"
                          >
                            <span>
                              <!-- {{ royaltyReportData.totalColumn.currency }} -->
                              {{ formatCurrency(main.totalValue) }} </span
                            ><br
                          /></span>
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          <span>
                            <!-- {{ royaltyReportData.totalColumn.currency }} -->
                            {{
                              formatCurrency(
                                royaltyReportData.totalColumn
                                  .lessOveragePaidTotal,
                              )
                            }}</span
                          >
                        </td>
                      </tr>
                      <tr>
                        <td
                          colspan="3"
                          class="px-1 whitespace-nowrap text-left"
                        >
                          Divers Paid
                        </td>
                        <td
                          colspan="2"
                          class="px-1 whitespace-nowrap text-right force-wrap"
                        >
                          <span
                            v-for="(terr, terrIndex) in optionTempTerritory"
                            :key="terrIndex"
                          >
                            {{ terr.ter }}
                            <small
                              v-if="reportMovieUniqueNo"
                              class="territory-unique-no"
                            >
                              | {{ reportMovieUniqueNo }}
                            </small>
                            <br
                          /></span>
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          <span
                            v-for="(
                              main, indexmain
                            ) in royaltyReportData.diverPaidSection"
                            :key="indexmain"
                          >
                            <span>
                              <!-- {{ royaltyReportData.totalColumn.currency }} -->
                              {{ formatCurrency(main.totalValue) }} </span
                            ><br
                          /></span>
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          <span>
                            <!-- {{ royaltyReportData.totalColumn.currency }} -->
                            {{
                              formatCurrency(
                                royaltyReportData.totalColumn
                                  .lessDiversPaidTotal,
                              )
                            }}</span
                          >
                        </td>
                      </tr>
                      <tr class="font-bold bg-gray-200">
                        <td
                          colspan="6"
                          class="px-1 whitespace-nowrap text-left"
                        >
                          Balance Payable
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          <span>
                            <!-- {{ royaltyReportData.totalColumn.currency }} -->
                            {{
                              formatCurrency(
                                royaltyReportData.totalColumn.balancePayable,
                              )
                            }}</span
                          >
                        </td>
                      </tr>
                      <!-- <tr class="spacing">
                        <th colspan="8" class="text-left">
                          Licensor Share of Corridor
                        </th>
                      </tr>
                      <tr>
                        <td colspan="7" class="text-left">
                          Licensor Share prior to recoupement on P&A
                        </td>
                        <td>
                          <b>
                            {{ royaltyReportData.totalColumn.currency }}
                            {{
                              formatCurrency(
                                royaltyReportData.totalColumn
                                  .licensorCorridorPriorToRecoupementOfPaSectionTotal
                              )
                            }}</b
                          >
                        </td>
                      </tr>
                      <tr>
                        <td colspan="7" class="text-left">
                          Licensor Share prior to recoupement on MG
                        </td>
                        <td>
                          <b>
                            {{ royaltyReportData.totalColumn.currency }}
                            {{
                              formatCurrency(
                                royaltyReportData.totalColumn
                                  .licensorCorridorPriorToRecoupementOfMgTotal
                              )
                            }}</b
                          >
                        </td>
                      </tr>
                      <tr>
                        <td colspan="7" class="text-left">
                          Total Licensor Corridor
                        </td>
                        <td>
                          <b>
                            {{ royaltyReportData.totalColumn.currency }}
                            {{
                              formatCurrency(
                                royaltyReportData.totalColumn.totalLicensorCoridor
                              )
                            }}</b
                          >
                        </td>
                      </tr>

                      <tr>
                        <td colspan="5" class="text-left">
                          Less Licensor corridor Paid
                        </td>
                        <td class="text-left">
                          <span
                            v-for="(terr, terrIndex) in optionTempTerritory"
                            :key="terrIndex"
                          >
                            {{ terr.ter }}
                            <small
                              v-if="reportMovieUniqueNo"
                              class="territory-unique-no"
                            >
                              | {{ reportMovieUniqueNo }}
                            </small>
                            <br
                          /></span>
                        </td>

                        <td>
                          <span
                            v-for="(
                              main, indexmain
                            ) in royaltyReportData.lessCoridorPaidSection"
                            :key="indexmain"
                          >
                            <b
                              >{{ royaltyReportData.totalColumn.currency }}
                              {{ formatCurrency(main.totalValue) }}</b
                            >
                            <br
                          /></span>
                        </td>
                        <td>
                          <b>
                            {{ royaltyReportData.totalColumn.currency }}
                            {{
                              formatCurrency(
                                royaltyReportData.totalColumn
                                  .lessLicensorCorridorPaid
                              )
                            }}
                          </b>
                        </td>
                      </tr>

                      <tr>
                        <td colspan="7" class="text-left">Balance Payable</td>
                        <td>
                          <b>
                            {{ royaltyReportData.totalColumn.currency }}
                            {{
                              formatCurrency(
                                royaltyReportData.totalColumn.balancePayableSecond
                              )
                            }}</b
                          >
                        </td>
                      </tr>

                      <tr>
                        <td colspan="7" class="text-left">Total Payable</td>
                        <td>
                          <b>
                            {{ royaltyReportData.totalColumn.currency }}
                            {{
                              formatCurrency(
                                royaltyReportData.totalColumn.totalFinalPayable
                              )
                            }}</b
                          >
                        </td>
                      </tr> -->
                    </tbody>
                  </table>
                </div>
                <div
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                  class="m-2"
                >
                  <b-button
                    :disabled="loading ? true : false"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="gradient-primary"
                    class="ml-2 borderRadius-10"
                    @click="showGenerateConfirm(royaltyReportData)"
                  >
                    <b-spinner v-if="loading" small /> Generate Royalty Report
                  </b-button>
                </div>
                <hr class="m-2" />
                <b-row> </b-row></div
            ></b-tab>
            <b-tab title="Existing Royalty Reports">
              <b-alert variant="secondary" show>
                <b-row cols="12" class="alert-heading">
                  <b-col
                    class="d-flex align-item-center justify-content-between"
                  >
                    <b-form-group v-slot="{ ariaDescribedby }">
                      <b-form-radio-group
                        @change="GetSavedReports"
                        id="radio-group-1"
                        v-model="selectedRadio"
                        :options="optionsRadio"
                        :aria-describedby="ariaDescribedby"
                        name="radio-options"
                        style="margin-top: 8px"
                      ></b-form-radio-group>
                    </b-form-group>
                    <div class="scroll-buttons">
                      <b-button
                        v-b-tooltip.hover.v-primary.top="buttonTooltip"
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="primary"
                        class="btn-icon rounded-circle dynamic-scroll-button"
                        @click="handleScrollClick"
                      >
                        <feather-icon :icon="buttonIcon" size="14" />
                      </b-button>
                    </div>
                  </b-col>
                </b-row>
              </b-alert>
              <b-card no-body>
                <div>
                  <b-table
                    hover
                    small
                    bordered
                    :fields="fields"
                    :items="savedReports"
                    empty-text="No  records found"
                    show-empty
                    responsive
                    ref="scrollableTable"
                  >
                    <template #cell(movie_title)="data">
                      <div style="width: 350px">
                        {{ data.item.movie_title }}
                      </div>
                    </template>
                    <template #cell(Sr)="data">
                      {{ data.index + 1 }}
                      <h6 v-if="data.item.isFinalReport == 1">
                        <b-badge variant="light-danger">{{
                          data.item.isFinalReport == 1 ? "Final/Last" : ""
                        }}</b-badge>
                      </h6>
                      <h6 v-if="data.item.isReportSent == 1">
                        <b-badge variant="light-danger">{{
                          data.item.isReportSent == 1 ? "Sent" : ""
                        }}</b-badge>
                      </h6>
                    </template>
                    <template #cell(dateFrom)="data">
                      {{
                        data.value
                          ? moment(data.item.dateFrom).format("DD/MM/YYYY") +
                            " to " +
                            moment(data.item.dateTo).format("DD/MM/YYYY")
                          : ""
                      }}
                    </template>

                    <template #cell(balance_to_favor)="data">
                      <b>{{
                        "CHF " + formatCurrency(data.item.balance_to_favor)
                      }}</b>
                    </template>

                    <template #cell(createdAt)="data">
                      {{
                        data.value
                          ? moment(data.value).format("DD/MM/YYYY")
                          : ""
                      }}
                    </template>

                    <template #cell(actions)="data">
                      <div class="text-nowrap">
                        <b-button
                          class="mr-1"
                          :variant="
                            selectedRadio != 'showdeleted'
                              ? 'outline-success'
                              : 'outline-danger'
                          "
                          size="sm"
                          style="width: 4.5rem"
                          @click="onPreviewRoyalty(data.item.royalty_report_id)"
                        >
                          <feather-icon
                            icon="EyeIcon"
                            size="16"
                            style="
                              font-weight: 600;
                              font-family: Verdana, Geneva, Tahoma, sans-serif;
                            "
                          />
                        </b-button>

                        <b-button
                          :variant="
                            selectedRadio != 'showdeleted'
                              ? 'outline-success'
                              : 'outline-danger'
                          "
                          size="sm"
                          style="width: 4.5rem; margin-right: 10px"
                          @click="
                            onDownloadRoyalty(
                              data.item.royalty_report_document,
                              data.item.company,
                            )
                          "
                        >
                          <feather-icon
                            icon="DownloadIcon"
                            size="16"
                            style="
                              font-weight: 600;
                              font-family: Verdana, Geneva, Tahoma, sans-serif;
                            "
                          />
                        </b-button>

                        <b-button
                          v-if="selectedRadio != 'showdeleted'"
                          variant="outline-success"
                          size="sm"
                          style="width: 4.5rem"
                          @click="handleDeleteRoyaltyReport(data.item)"
                        >
                          <feather-icon
                            icon="TrashIcon"
                            size="16"
                            style="
                              font-weight: 600;
                              font-family: Verdana, Geneva, Tahoma, sans-serif;
                            "
                          />
                        </b-button>
                        <!-- </div>   -->

                        <br />
                        <!-- <invoice-sidebar-send-invoice
                        ref="sendInvoiceSidebar"
                        :id="data.item.royalty_report_id"
                        type="RoyaltyInvEmail"
                        hide=false
                      /> -->
                        <b-button
                          v-if="selectedRadio != 'showdeleted'"
                          block
                          class="mt-1"
                          variant="outline-success"
                          size="sm"
                          @click="handleMarkAsSent(data.item)"
                          >{{
                            data.item.isReportSent == 0 ? "Set " : "Unset"
                          }}
                          Report as Sent</b-button
                        >
                        <b-button
                          v-if="selectedRadio != 'showdeleted'"
                          block
                          class="mt-1"
                          variant="outline-success"
                          size="sm"
                          @click="handleMarkAsFinal(data.item)"
                          >{{
                            data.item.isFinalReport == 0 ? "Set " : "Unset"
                          }}
                          Report as final/last</b-button
                        >
                        <!-- <b-tooltip
                        title="Preview Report"
                        class="cursor-pointer"
                        :target="`invoice-row-${data.item.royalty_report_id}-send-icon`"
                      /> -->
                        <b-button
                          v-if="selectedRadio != 'showdeleted'"
                          block
                          class="mt-1"
                          variant="outline-success"
                          size="sm"
                          @click="handleSendButtonClicked(data.item)"
                        >
                          Send Royalty Report</b-button
                        >
                      </div>
                    </template>
                  </b-table>
                </div>
                <invoice-sidebar-send-invoice
                  :key="sidebarKey"
                  ref="sendInvoiceSidebar"
                  :id="selectedRoyaltyReportId"
                  type="RoyaltyInvEmail"
                />
                <template #footer>
                  <div class="mx-2 mb-2">
                    <b-row>
                      <!-- Pagination -->
                      <b-col
                        class="d-flex align-items-center justify-content-center justify-content-sm-center"
                      >
                        <b-pagination
                          @change="onPageChange"
                          v-model="pagination.currentPage"
                          :total-rows="pagination.total"
                          :per-page="pagination.perPage"
                          first-number
                          last-number
                          class="mb-0 mt-1 mt-sm-0"
                          prev-class="prev-item"
                          next-class="next-item"
                          :limit="15"
                        >
                          <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                          </template>
                          <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                          </template>
                        </b-pagination>
                      </b-col>
                    </b-row>
                  </div>
                </template> </b-card
            ></b-tab>
            <!-- <b-tab title="Pending Royalty Reports As Per Statement Period">
           
              <div v-if="tabIndex == 2">
                <pending-royalty-report
                  ref="pendingComponentRef"
                  @setReportDataEmit="getReportData"
                  :selectedVendorId="
                    selectedCustomer ? selectedCustomer.vendor_id : null
                  "
                  :selectedMovieId="
                    selectedMovie && selectedMovie.movie_id
                      ? selectedMovie.movie_id
                      : null
                  "
                />
              </div>
            </b-tab> -->
          </b-tabs>
        </div>
      </b-col>
    </b-row>
    <div>
      <b-modal
        scrollable
        v-model="modalContract"
        id="modalContract"
        size="xl"
        hide-footer
      >
        <b-table
          bordered
          class="position-relative"
          primary-key="contract_id"
          responsive
          show-empty
          :items="contractsList"
          :fields="fieldsContract"
          hover
        >
          <!-- hover -->
          <template #head(selected)="data">
            <b-form-checkbox
              @change="selectAllRows"
              v-model="selectAllStatus"
              value="1"
              unchecked-value="0"
            >
            </b-form-checkbox>
          </template>
          <template v-slot:cell(selected)="data">
            <b-form-checkbox
              v-model="selectedRotaltyContracts"
              :value="data.item"
            >
            </b-form-checkbox>
          </template>
          <template #cell(contract_id)="data">
            {{ data.item.contract_id }}
          </template>

          <template #cell(company)="data">
            <div style="width: max-content">
              <b-badge variant="light-success">
                {{ data.item.contract_nature }}
                {{ data.item.draft ? "(draft)" : "" }}</b-badge
              ><br />{{ data.item.company }}
            </div>
          </template>
          <template #cell(title)="data">
            <div style="width: max-content" v-html="data.value"></div>
          </template>
          <template #cell(territory)="data">
            <span>
              {{ data.value }}
            </span>
          </template>
          <template #cell(right)="data">
            <span>
              {{ data.value }}
            </span>
          </template>
          <template #cell(language)="data">
            <span>
              {{ data.value }}
            </span>
          </template>
          <template #cell(purchaseDate)="data">
            <b-badge variant="light-info"
              >Contract Date : {{ data.item.purchaseDate }} </b-badge
            ><br />
            <b-badge variant="light-success" class="mt-1">
              Start : {{ data.item.rStart }} </b-badge
            ><br />

            <b-badge variant="light-danger" class="mt-1">
              End : {{ data.item.rExpiry }}</b-badge
            >
          </template>
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <b-button
                variant="primary"
                size="sm"
                @click="getRoyaltyReportMultiple(data.item)"
              >
                Preview Report </b-button
              ><br />
              <b-badge
                variant="warning"
                v-if="selectedContractID === data.item.contract_id"
                >currently on preview</b-badge
              >

              <!-- <b-button
                size="sm"
                @click="data.toggleDetails, getRoyaltyReportMultiple(data.item)"
              >
                {{ data.detailsShowing ? "Hide" : "Show" }} Details
              </b-button> -->
            </div>
          </template>
          <template #row-details="row"> </template>
          <template #cell()="data">
            <span class="text-nowrap">{{ data.value }}</span>
          </template>
        </b-table>
      </b-modal>
    </div>
    <b-modal
      scrollable
      v-model="modalPreview"
      id="modalPreview"
      size="xl"
      hide-footer
    >
      <preview-invoice
        :selected_royalty_report_id="selected_royalty_report_id"
      />
    </b-modal>
    <div>
      <revenue-expenses-contract
        :type="selected_type"
        :showModals="showRevenueExpensesModal"
        :contract_id="reportContractId"
        @modal-cancel="handleRevenueExpensesModalCancel"
      />
    </div>
    <!-- <invoice-sidebar-send-invoice />
    <invoice-sidebar-add-payment /> -->
  </section>
</template>

<script>
import Logo from "@core/layouts/components/Logo.vue";
import Ripple from "vue-ripple-directive";
import { labels } from "@/utils/constants";
import * as ContractServices from "@/apiServices/ContractServices";
import previewInvoice from "./PreviewRoyaltyReport.vue";
import pendingRoyaltyReport from "./PendingRoyaltyReports.vue";
import showModal from "@/views/components/ModalConfirmation";

import {
  GetRoyaltyReportDataTerritory,
  GetRoyaltyReportList,
  GenerateRoyaltyReportPDF,
  GetMoviesVendor,
  GetVendorMovies,
  DeleteRoyaltyReport,
} from "@/apiServices/RevenueServies";
import { formatCurrency } from "@/utils/helpers";

import { getAllMovie } from "@/apiServices/MovieServices";
import { getAllVendor } from "@/apiServices/VendorServices";

import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BButton,
  BCardText,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BFormTextarea,
  BFormCheckbox,
  BPopover,
  BAlert,
  BLink,
  VBToggle,
  BTable,
  BTooltip,
  BSpinner,
  BPagination,
  BTabs,
  BTab,
  BModal,
  BBadge,
  BFormRadio,
  BFormRadioGroup,
  BListGroup,
  BListGroupItem,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import moment from "moment";
import ToastificationContentVue from "@core/components/toastification/ToastificationContent.vue";
import InvoiceSidebarSendInvoice from "../Revenue/InvoiceSidebarSendInvoice.vue";
// import InvoiceSidebarAddPayment from '../InvoiceSidebarAddPayment.vue'
import RevenueExpensesContract from "../Revenue/RevenueExpensesContract.vue";

export default {
  components: {
    BRow,
    BTabs,
    BTab,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BCardText,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BFormTextarea,
    BFormCheckbox,
    BPopover,
    BAlert,
    BLink,
    flatPickr,
    vSelect,
    Logo,
    BTable,
    BTooltip,
    ToastificationContentVue,
    BSpinner,
    BPagination,
    BModal,
    BBadge,
    BFormRadio,
    previewInvoice,
    BFormRadioGroup,
    pendingRoyaltyReport,
    BListGroup,
    BListGroupItem,
    InvoiceSidebarSendInvoice,
    // InvoiceSidebarAddPayment,
    RevenueExpensesContract,
  },
  directives: {
    Ripple,
    "b-toggle": VBToggle,
  },

  data() {
    return {
      selectedRadio: "all",
      optionsRadio: [
        { text: "All", value: "all" },
        { text: "Sent", value: "isReportSent" },
        { text: "Final/Last", value: "isFinalReport" },
        { text: "Show Deleted Reports", value: "showdeleted" },
      ],
      BASE_URL_FILES: process.env.VUE_APP_FILESURL + "/",
      moment: moment,
      pagination: {
        currentPage: 1,
        total: null,
        perPage: 10,
      },
      selectAllStatus: "0",
      selectedRotaltyContracts: [],
      selected_royalty_report_id: null,
      perPageOptions: [10, 25, 50, 100],
      filters: {
        reportType: "territory",
        showReportBy: "vendor",
        reportView: "rights",
        licensor: null,
        movie: null,
        revenueDate: null,
      },
      fields: [
        "Sr",
        { key: "company", label: "Licensor" },
        { key: "movie_title", label: "Movie" },

        // { key: "territory_name", label: "Territory" },
        { key: "dateFrom", label: "Duration" },
        { key: "balance_to_favor", label: "Balance to favor/Unrecouped" },

        { key: "createdAt", label: "Report Generate Date" },
        { key: "reportSentTo", label: "Sent to" },
        { key: "reportDescription", label: "Comments" },
        { key: "actions", label: "Actions" },
      ],
      // selectedCustomer: null,
      // orderValue: "vendor",
      // reportTypeValue: "territory",
      loading: false,
      tabIndex: 0,
      modalContract: false,
      modalPreview: false,
      // revenueDateRange: null,
      optionCustomer: [],
      optionCustomerTemp: [],
      optionTempTerritory: [],
      optionSearchTerritory: [],
      selectedTempTerritory: [],
      optionMovies: [],
      optionMultipleMovies: [],
      optionVendors: [],
      optionAvailableTeritory: [],
      isMovieLoading: false,
      isVendorLoading: false,

      // selectedMovie: null,
      movieName: null,
      reportContractId: null,
      selectedContractID: null,
      optionTeritory: [],
      contractsList: [],
      allTeritory: [],
      savedReports: [],
      vendorAllReports: [],
      trl_territories: [],
      selectedTeritory: null,
      royaltyReportData: null,
      isFinalReport: false,
      finalReportstatus: false,
      isGenerateAll: false,
      reportDescription: null,
      reportSentTo: null,
      reportSearchSection: true,
      showReportSearchSection: true,
      fieldsContract: [
        { key: "selected", label: "", stickyColumn: true },

        {
          key: "actions",
          label: "Actions",
          stickyColumn: true,
          variant: "primary",
        },

        {
          key: "company",
          label: "Contact",
        },
        {
          key: "title",
          label: "Movie",
        },
        {
          key: "territory",
          label: "territory",
        },
        {
          key: "right",
          label: "rights",
        },
        {
          key: "language",
          label: "languages",
        },
        {
          key: "purchaseDate",
          label: "contract dates",
        },

        {
          key: "language",
          label: "languages",
        },
        { key: "contract_id", label: "Contract ID" },
      ],
      showRevenueExpensesModal: false,
      selected_type: "royalty_report_territory",
      currentContractData: null,
      scrollPosition: 0,
      maxScroll: 0,
      isAtRightEnd: false,
      showScrollButtons: true,
      selectedRoyaltyReportId: null,
      sidebarKey: 0,
      sidebarType: "",
      isSendButtonClicked: false,
      lastFetchedFilterSnapshot: null,
      hasFetchedTerritoryReport: false,
      leftPaneWidth: 34,
      isPaneResizing: false,
      viewportWidth: typeof window !== "undefined" ? window.innerWidth : 1920,
    };
  },

  mounted() {
    this.filters.reportType = "territory";
    window.addEventListener("resize", this.onWindowResize);

    this.$nextTick(() => {
      this.updateScrollState();
      const el = this.getTableElement();
      if (el) {
        el.addEventListener("scroll", this.handleScroll);
        setTimeout(this.updateScrollState, 300); // Wait for DOM to render
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onWindowResize);
    document.removeEventListener("mousemove", this.onPaneResizeMove);
    document.removeEventListener("mouseup", this.stopPaneResize);
    const el = this.getTableElement();
    if (el) {
      el.removeEventListener("scroll", this.handleScroll);
    }
  },

  async beforeMount() {
    this.filters.reportType = "territory";
    this.loadFilterList();
    if (this.filters.showReportBy == "vendor") {
      this.getLicensorMovies("no");
    } else {
      this.getMoviesLicensor();
    }
    this.GetSavedReports();
    this.GetAllVendor();
    this.GetAllMovie();
    await this.$store.dispatch("master/setLabelTreeMaster", {
      key: labels.territory_tree,
      master: labels.territory,
      sub_master: labels.sub_territory,
    });
  },

  computed: {
    isAtLeftEnd() {
      return this.scrollPosition <= 0;
    },
    buttonIcon() {
      return this.isAtRightEnd ? "ArrowLeftIcon" : "ArrowRightIcon";
    },
    buttonTooltip() {
      return this.isAtRightEnd ? "Scroll to beginning" : "Scroll to end";
    },
    isDesktopView() {
      return this.viewportWidth >= 1200;
    },
    showPaneResizer() {
      return this.reportSearchSection && this.isDesktopView;
    },
    leftPaneStyle() {
      if (!this.showPaneResizer) return {};
      return {
        flex: `0 0 ${this.leftPaneWidth}%`,
        maxWidth: `${this.leftPaneWidth}%`,
      };
    },
    rightPaneStyle() {
      if (!this.showPaneResizer) return {};
      const width = 100 - this.leftPaneWidth;
      return {
        flex: `0 0 ${width}%`,
        maxWidth: `${width}%`,
      };
    },
    reportMovieUniqueNoList() {
      const titleCandidates = [];
      if (this.filters.movie && this.filters.movie.full_title) {
        titleCandidates.push(String(this.filters.movie.full_title));
      }
      if (this.filters.movie && this.filters.movie.multi_movies) {
        titleCandidates.push(
          ...String(this.filters.movie.multi_movies).split(","),
        );
      }
      if (this.currentContractData && this.currentContractData.title_for_rr) {
        titleCandidates.push(
          ...String(this.currentContractData.title_for_rr).split("<br/>"),
        );
      }
      const uniqueNos = [];
      for (const raw of titleCandidates) {
        const value = String(raw || "").trim();
        if (!value) continue;
        const token = value.split("-")[0].trim();
        if (/^\d+$/.test(token) && !uniqueNos.includes(token)) {
          uniqueNos.push(token);
        }
      }
      return uniqueNos.length ? uniqueNos : ["0"];
    },
    reportMovieUniqueNo() {
      return "";
    },
    activeContractTerritoryIdSet() {
      const c = this.currentContractData;
      if (!c) return new Set();
      const fromIds = c.territory_ids
        ? String(c.territory_ids)
            .split(",")
            .map((s) => Number(String(s).trim()))
            .filter((n) => !Number.isNaN(n))
        : [];
      if (fromIds.length) return new Set(fromIds);
      if (this.optionTempTerritory && this.optionTempTerritory.length) {
        return new Set(
          this.optionTempTerritory
            .map((t) => Number(t.id))
            .filter((n) => !Number.isNaN(n)),
        );
      }
      return new Set();
    },
    contractTerritoryTreeOptions() {
      const tree = this.$store.state.master.territory_tree || [];
      const set = this.activeContractTerritoryIdSet;
      if (!set.size) return [];
      return this.enableTerritoryTreeSelection(
        this.filterTerritoryTreeByIds(tree, set),
      );
    },
    currentFilterSnapshot() {
      return {
        licensor_id:
          this.filters.licensor && this.filters.licensor.vendor_id
            ? Number(this.filters.licensor.vendor_id)
            : null,
        movie_id:
          this.filters.movie && this.filters.movie.movie_id
            ? Number(this.filters.movie.movie_id)
            : null,
        movie_multi_ids:
          this.filters.movie && this.filters.movie.multi_movies_ids
            ? String(this.filters.movie.multi_movies_ids)
            : null,
      };
    },
    canRefetchTerritoryReport() {
      if (!this.hasFetchedTerritoryReport || !this.currentContractData)
        return false;
      if (!this.lastFetchedFilterSnapshot) return false;
      const current = this.currentFilterSnapshot;
      const prev = this.lastFetchedFilterSnapshot;
      return (
        current.licensor_id === prev.licensor_id &&
        current.movie_id === prev.movie_id &&
        current.movie_multi_ids === prev.movie_multi_ids
      );
    },
    contractTerritoryTreeLines() {
      const fromTree = this.flattenTerritoryTreeLines(
        this.contractTerritoryTreeOptions,
      );
      if (fromTree.length) return fromTree;
      if (this.optionTempTerritory && this.optionTempTerritory.length) {
        return this.optionTempTerritory.map((t) => ({
          label: t.ter,
          depth: 0,
        }));
      }
      const c = this.currentContractData;
      if (c && c.territory) {
        return String(c.territory)
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean)
          .map((label) => ({ label, depth: 0 }));
      }
      return [];
    },
  },
  watch: {
    // limit() {
    //   this.getAllRevenueData();
    // },
    // currentPage() {
    //   this.getAllRevenueData();
    //   this.$refs["table_container"].scrollIntoView({ behavior: "smooth" });
    // },
    selectedRotaltyContracts() {
      if (this.selectedRotaltyContracts.length > 0) {
        if (this.selectedRotaltyContracts.length != this.contractsList.length) {
          this.selectAllStatus = "0";
        } else {
          this.selectAllStatus = "1";
        }
      } else {
      }
    },
  },

  methods: {
    formatCurrency,
    getColumnRowCount(mainSectionRow, columnKey) {
      if (!mainSectionRow || typeof mainSectionRow !== "object") return 1;
      const target = mainSectionRow[columnKey];
      if (Array.isArray(target) && target.length) return target.length;
      let max = 1;
      Object.keys(mainSectionRow).forEach((key) => {
        const value = mainSectionRow[key];
        if (Array.isArray(value)) {
          max = Math.max(max, value.length);
        }
      });
      return max;
    },
    getMovieUniqueNoByRow(rowIndex) {
      const ids =
        this.reportMovieUniqueNoList && this.reportMovieUniqueNoList.length
          ? this.reportMovieUniqueNoList
          : ["0"];
      if (rowIndex < ids.length) return ids[rowIndex];
      return ids[ids.length - 1];
    },
    onWindowResize() {
      this.viewportWidth = window.innerWidth;
      if (!this.isDesktopView && this.isPaneResizing) {
        this.stopPaneResize();
      }
    },
    startPaneResize() {
      if (!this.showPaneResizer) return;
      this.isPaneResizing = true;
      document.addEventListener("mousemove", this.onPaneResizeMove);
      document.addEventListener("mouseup", this.stopPaneResize);
    },
    onPaneResizeMove(event) {
      if (!this.isPaneResizing) return;
      const container = this.$el.querySelector(".invoice-add");
      if (!container) return;
      const rect = container.getBoundingClientRect();
      if (!rect.width) return;
      const next = ((event.clientX - rect.left) / rect.width) * 100;
      this.leftPaneWidth = Math.max(24, Math.min(55, next));
    },
    stopPaneResize() {
      this.isPaneResizing = false;
      document.removeEventListener("mousemove", this.onPaneResizeMove);
      document.removeEventListener("mouseup", this.stopPaneResize);
    },
    filterTerritoryTreeByIds(nodes, allowedSet) {
      if (!nodes || !nodes.length) return [];
      const out = [];
      for (const node of nodes) {
        const nodeId = Number(node.id);
        const filteredChildren =
          node.children && node.children.length
            ? this.filterTerritoryTreeByIds(node.children, allowedSet)
            : [];
        const nodeSelected = allowedSet.has(nodeId);
        if (nodeSelected || filteredChildren.length) {
          const copy = JSON.parse(JSON.stringify(node));
          copy.children = filteredChildren;
          out.push(copy);
        }
      }
      return out;
    },
    enableTerritoryTreeSelection(nodes) {
      if (!nodes || !nodes.length) return [];
      return nodes.map((node) => {
        const copy = JSON.parse(JSON.stringify(node));
        copy.isDisabled = false;
        copy.disabled = false;
        if (copy.children && copy.children.length) {
          copy.children = this.enableTerritoryTreeSelection(copy.children);
        }
        return copy;
      });
    },
    flattenTerritoryTreeLines(nodes, depth = 0) {
      const lines = [];
      if (!nodes || !nodes.length) return lines;
      for (const n of nodes) {
        lines.push({ label: n.label, depth });
        if (n.children && n.children.length) {
          lines.push(...this.flattenTerritoryTreeLines(n.children, depth + 1));
        }
      }
      return lines;
    },

    getReportIndex(contractId) {
      const index = this.selectedRotaltyContracts.findIndex(
        (item) => item.contract_id === contractId,
      );
      return index >= 0 ? index + 1 : "";
    },
    getOptionLabel(option) {
      return `Report ${this.getReportIndex(
        option.contract_id,
      )} - ${this.formattedTitle(option.title)}`;
    },
    formattedTitle(title) {
      return title.includes("<br/>") ? "Various" : title;
    },
    handleReportSelect(contractId) {
      const selected = this.selectedRotaltyContracts.find(
        (item) => item.contract_id === contractId,
      );
      if (selected) {
        this.getRoyaltyReportMultiple(selected);
      }
    },
    handleSendButtonClicked(dataArray) {
      console.log(dataArray, "value send to component");
      this.isSendButtonClicked = true;
      this.selectedRoyaltyReportId = dataArray.royalty_report_id;
      this.sidebarKey++;
      // const correspondingVendor = this.optionVendors.find(vendor =>
      //    vendor.vendor_id === dataArray.vendor_id // Assuming item has vendor_id that matches
      // );
      // console.log(correspondingVendor,'matchingVendor') ;
      this.$nextTick(() => {
        if (this.$refs.sendInvoiceSidebar) {
          console.log(
            "vendor",
            this.optionVendors.filter(
              (vendor) => vendor.vendor_id === dataArray.vendor_id,
            ),
          );
          const contact_emails = this.optionVendors
            .filter((vendor) => vendor.vendor_id === dataArray.vendor_id)
            .map((vendor) =>
              vendor.vendor_contactpersons ? vendor.vendor_contactpersons : [],
            );
          console.log(contact_emails, "contact_emails");
          this.$refs.sendInvoiceSidebar.showSidebar(dataArray, contact_emails);
          // console.log('dataArray',dataArray) ;
        }
      });
    },
    showInvoiceSidebar(type) {
      this.sidebarType = type;
      this.$nextTick(() => {
        if (this.$refs.sendInvoiceSidebar) {
          this.$refs.sendInvoiceSidebar.showSidebar(type);
        }
      });
    },

    async onReportChange() {
      this.onChange();
      if (this.filters.reportType == "default") {
        this.$router.push(`/generateroyalty`);
      }
    },

    async onDownloadRoyalty(file, outputFileName) {
      const fileName = this.BASE_URL_FILES + file;

      try {
        const response = await fetch(fileName);
        const blob = await response.blob();
        const url = await URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = outputFileName + ".pdf";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } catch (err) {
        console.log({ err });
      }
    },
    async onGenrateAll() {
      this.isGenerateAll = true;

      for (let i of this.selectedRotaltyContracts) {
        this.loading = true;
        await this.getRoyaltyReportMultiple(i);

        await this.GenerateRoyaltyReportPdf(this.royaltyReportData);
      }
      this.loading = false;
      this.tabIndex = 1;
      this.loadFilterList();
      this.GetSavedReports();
      this.$toast({
        component: ToastificationContentVue,
        props: {
          title: "Generated Succesfully",
          icon: "EditIcon",
          variant: "success",
        },
      });
    },
    selectAllRows() {
      if (this.selectAllStatus == "1") {
        this.selectedRotaltyContracts = this.contractsList;
      } else {
        this.selectedRotaltyContracts = [];
      }
    },
    async getReportData(data) {
      let nextFromDate = data.lastReportCreatedDate
        ? moment(data.lastReportCreatedDate).format("YYYY-MM-DD")
        : moment(data.contractCreatedDate).format("YYYY-MM-DD");
      let nextToDate = null;
      if (data.statementPeriod == "1") {
        nextToDate = moment(nextFromDate).add(1, "months");
      } else if (data.statementPeriod == "2") {
        nextToDate = moment(nextFromDate).add(6, "months");
      } else if (data.statementPeriod == "3") {
        nextToDate = moment(nextFromDate).add(3, "months");
      } else if (data.statementPeriod == "4") {
        nextToDate = moment(nextFromDate).add(12, "months");
      }
      nextToDate = moment(nextToDate).format("YYYY-MM-DD");
      this.filters.revenueDate = nextFromDate + " to " + nextToDate;
      this.getRoyaltyReportMultiple(data);
    },
    async onPreviewRoyalty(id) {
      this.selected_royalty_report_id = id;
      this.modalPreview = true;
    },
    async onOrderChange() {
      this.filters.movie = null;
      this.filters.licensor = null;
      this.filters.revenueDate = null;
      this.royaltyReportData = null;
      if (this.filters.showReportBy == "vendor") {
        //this.GetAllVendor();
      } else if (this.filters.showReportBy == "movie") {
        // this.GetAllMovie();
      }
      this.onChange();
    },

    async handleDeleteRoyaltyReport(item) {
      if (item.isFinalReport == 1 || item.isReportSent == 1) {
        let reasons = [];

        if (item.isFinalReport == 1) {
          reasons.push("Final/Last");
        }
        if (item.isReportSent == 1) {
          reasons.push("Sent");
        }
        const message = `You cannot delete this report as it is set to ${reasons.join(
          " and ",
        )}.`;

        await this.showModal(message, "delete", false);
        return;
      }
      const confirmation = await this.showModal(
        "Are you sure you want to delete this royalty report?",
        "delete",
      );
      if (confirmation) {
        try {
          const payload = { royalty_report_id: item.royalty_report_id };
          const response = await DeleteRoyaltyReport(payload);

          if (response.data.status) {
            this.$toast({
              component: ToastificationContentVue,
              props: {
                title: "Report Deleted successfully",
                icon: "EditIcon",
                variant: "success",
              },
            });
            this.GetSavedReports();
          } else {
            this.$toast({
              component: ToastificationContentVue,
              props: {
                title: response.data.message || "Delete failed",
                icon: "EditIcon",
                variant: "danger",
              },
            });
          }
        } catch (err) {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: "Error deleting report",
              icon: "EditIcon",
              variant: "danger",
            },
          });
        }
      }
    },
    showModal(text = "Are You Sure?", type = "save", withButtons = true) {
      if (withButtons) {
        return this.$bvModal.msgBoxConfirm(text, {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: type == "save" ? "success" : "danger",
          cancelVariant: type == "save" ? "outline-success" : "outline-danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        });
      } else {
        return this.$bvModal.msgBoxOk(text, {
          title: "Information",
          size: "sm",
          buttonSize: "sm",
          okVariant: "primary",
          okTitle: "OK",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        });
      }
    },

    async GetSavedReports() {
      try {
        let payload = {
          page: this.pagination.currentPage,
          reportContractId: this.reportContractId,
          limit: this.pagination.perPage ? this.pagination.perPage : null,
          vendor_id:
            this.filters.licensor && this.filters.licensor.vendor_id
              ? this.filters.licensor.vendor_id
              : null,
          movie_id:
            this.filters.movie && this.filters.movie.movie_id
              ? this.filters.movie.movie_id
              : null ||
                (this.filters.movie && this.filters.movie.multi_movies_ids)
              ? this.filters.movie.multi_movies_ids
              : null,
          territory_id: this.selectedTeritory ? this.selectedTeritory : null,
          selectedRadio: this.selectedRadio,
          // range: this.revenueDateRange
          //   ? this.revenueDateRange.split("to")
          //   : null,
        };
        const response = await GetRoyaltyReportList(payload);

        if (!response.status) {
          return this.$toast({
            component: ToastificationContentVue,
            props: {
              title: response.data.message || "Data not found!",
              icon: "EditIcon",
              variant: "danger",
            },
          });
        }
        this.savedReports = response.data.data.data;
        if (
          response.data.data.hasOwnProperty("pagination") &&
          response.data.data.pagination.total
        ) {
          this.pagination.total = response.data.data.pagination.total;
        }
      } catch (err) {
        console.log("Error in getting movies list ", err);
      }
    },
    async GetAllMovie() {
      this.isMovieLoading = true;
      try {
        const response = await getAllMovie({ archived: false, draft: false });
        if (response.data) {
          this.optionMovies = response.data.data.data;
        }
      } catch (err) {
        console.log("Error in getting movies list ", err);
      } finally {
        this.isMovieLoading = false;
      }
    },

    async GetAllVendor() {
      this.isVendorLoading = true;
      try {
        const response = await getAllVendor({
          contact_type: "Royalty report",
          lbl_cat: "contact_type",
        });
        if (response.data) {
          this.optionVendors = response.data.data.data;
        }
      } catch (err) {
        console.log("Error in getting movies list ", err);
      } finally {
        this.isVendorLoading = false;
      }
    },
    async updateFinalStatus(reportId, finalStatus, isReportSent, type) {
      try {
        let final;
        let sent;
        if (type == "final") {
          final = finalStatus && finalStatus == 1 ? 0 : 1;
        } else {
          final = finalStatus;
        }

        if (type == "sent") {
          sent = isReportSent && isReportSent == 1 ? 0 : 1;
        } else {
          sent = isReportSent;
        }

        const response = await GenerateRoyaltyReportPDF({
          royalty_report_id: reportId,
          finalStatus: final,
          isReportSent: sent,
        });
        if (response.data.status) {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: response.data.message,
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.loadFilterList();
          this.GetSavedReports();
        }
      } catch (error) {
        console.log("Error in updating status");
      }
    },
    onSelect(selectedMovie) {
      // console.log(selectedMovie);
      // let getData = this.vendorAllReports.filter((z) => {
      //   return (
      //     z.movie_id == selectedMovie.multi_movies_ids &&
      //     String(z.vendor_id) == String(selectedMovie.vendor_id)
      //   );
      // });
      // console.log(getData, "movie");
      // if (getData.length) {
      //   this.revenueDateRange = getData[0].dateTo;
      // } else {
      //   this.revenueDateRange = "";
      // }
    },
    onTabChange() {
      this.filters.movie = null;
      this.movieName = null;
      this.filters.licensor = null;
      this.filters.revenueDate = null;
    },

    onPageChange() {
      this.$nextTick(() => {
        this.loadFilterList();
        this.GetSavedReports();
      });
    },

    async getLicensorMovies(isMultiple) {
      this.optionMultipleMovies = [];
      this.vendorAllReports = [];
      this.isMovieLoading = true;
      try {
        const response = await GetVendorMovies({
          vendor_id: this.filters.licensor.vendor_id,
          isMultiple: isMultiple,
        });
        if (response.data.status) {
          this.optionMultipleMovies = response.data.data.vendors;
          this.vendorAllReports = response.data.data.reportStrtDate;
          if (this.optionMultipleMovies.length == 1) {
            this.filters.movie = this.optionMultipleMovies[0];
            //this.onSelect(this.selectedMovie);
          }
          const notSameMovieOption = !this.optionMultipleMovies.some(
            (MovieOption) =>
              MovieOption.contract_id === this.filters.movie.contract_id,
          );
          if (notSameMovieOption) {
            this.filters.movie = null;
          }
        }
      } catch (error) {
        console.log("Error in getting Contracts List");
      } finally {
        this.isMovieLoading = false;
      }
      this.onChange();
    },
    async getMoviesLicensor() {
      this.optionCustomer = [];
      // this.selectedCustomer = null;
      this.isVendorLoading = true;

      try {
        const response = await GetMoviesVendor({
          movie_id: this.filters.movie.movie_id,
        });
        if (response.data.status) {
          this.optionCustomer = response.data.data;
        }
        const notSameLicensorOption = !this.optionCustomer.some(
          (VendorOption) =>
            VendorOption.vendor_id === this.filters.licensor.vendor_id,
        );
        if (notSameLicensorOption) {
          this.filters.licensor = null;
        }
      } catch (error) {
        console.log("Error in getting Contracts List");
      } finally {
        this.isVendorLoading = false;
      }
      this.onChange();
    },
    searchSavedReports() {
      this.tabIndex = this.tabIndex;
      this.royaltyReportData = null;
      if (this.tabIndex == 2) {
        this.$refs.pendingComponentRef.getContractsList();
      }
      this.loadFilterList();
      this.GetSavedReports();
    },

    async GenerateRoyaltyReportPdf(payload) {
      this.loading = true;
      try {
        payload.searchValues = {
          vendor_id: this.filters.licensor.vendor_id,
          movie_id:
            this.filters.movie && this.filters.movie.movie_id
              ? this.filters.movie.movie_id
              : null,
          reportContractId: this.reportContractId,
          territory_id: 0,
          expense_date: this.filters.revenueDate,
        };
        let vendorData = this.optionVendors.filter((x) => {
          return x.vendor_id == this.filters.licensor.vendor_id;
        });
        if (vendorData.length) {
          this.filters.licensor = vendorData[0];
        }
        payload.headData = {
          territory_name: "",
          tilte_name:
            this.filters.movie && this.filters.movie.title
              ? this.filters.movie.title
              : null,
          vendor_name: this.filters.licensor,
        };
        payload.isFinalReport = this.isFinalReport == true ? 1 : 0;
        payload.reportDescription = this.reportDescription;
        payload.reportSentTo = this.reportSentTo;
        payload.isRRTerritoryWise = true;
        let tempReportHtml = this.$refs.rrt_table;
        payload.reportHtml = tempReportHtml.outerHTML;

        // /console.log(payload.reportHtml.outerHTML, "hh");

        const response = await GenerateRoyaltyReportPDF(payload);
        if (response.data.status) {
          if (this.isGenerateAll == false) {
            this.$toast({
              component: ToastificationContentVue,
              props: {
                title: response.data.message || "PDF Generated Succesfully",
                icon: "EditIcon",
                variant: "success",
              },
            });
            this.selected_royalty_report_id =
              response.data.data.royalty_report_id;
            this.modalPreview = true;
            this.loadFilterList();
            this.GetSavedReports();
          }
          // this.$router.push({
          //   name: "PreviewRoyaltyReport",
          //   params: {
          //     royalty_report_id: response.data.data.royalty_report_id,
          //   },
          // });
          //this.searchSavedReports();
          this.loading = false;

          //this.optionCustomer = response.data.data.rows;
        }
      } catch (err) {
        this.loading = false;
        console.log("Error in adding ", err);
      }
    },

    async getReportContracts() {
      this.loadFilterList();
      try {
        const response = await ContractServices.getAllContract({
          movie:
            this.filters.movie && this.filters.movie.multi_movies_ids
              ? this.filters.movie.multi_movies_ids
              : this.filters.movie && this.filters.movie.movie_id
              ? this.filters.movie.movie_id
              : null,
          vendor: this.filters.licensor
            ? this.filters.licensor.vendor_id
            : null,
          contract_nature: "Acquisition",
        });
        this.contractsList = response.data.data.contracts;

        if (!response.data.data.contracts.length) {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: "Acquisition Contract Not Found!",
              icon: "EditIcon",
              variant: "danger",
            },
          });
        }
        //  else if (this.contractsList.length == 1) {
        //   this.getRoyaltyReportMultiple(this.contractsList[0].contract_id);
        // }
        else {
          this.modalContract = true;
        }
      } catch (error) {
        console.log("Error in getting Contracts List", error);
      }
    },
    async onRefetchReport() {
      if (!this.canRefetchTerritoryReport) return;
      await this.getRoyaltyReportMultiple(this.currentContractData, {
        keepSelectedTerritory: true,
      });
    },
    async getRoyaltyReportMultiple(contractData, options = {}) {
      const keepSelectedTerritory = !!options.keepSelectedTerritory;
      this.currentContractData = contractData;
      this.optionTempTerritory = [];
      if (!keepSelectedTerritory) {
        this.selectedTempTerritory = [];
      }
      this.royaltyReportData = null;
      this.selectedContractID = contractData.contract_id;
      this.tabIndex = 0;
      let obj = {
        vendor_id: contractData.vendor_id,
        company: contractData.company,
      };

      this.filters.licensor = obj;

      this.modalContract = false;
      this.reportContractId = contractData.contract_id;

      try {
        const selectedTerritoryIds = Array.isArray(this.selectedTempTerritory)
          ? this.selectedTempTerritory
              .map((id) => Number(id))
              .filter((id) => !Number.isNaN(id))
          : [];
        const isTerritoryFilterApplied = selectedTerritoryIds.length > 0;
        const contractTerritoryIds = contractData.territory_ids
          ? contractData.territory_ids
              .split(",")
              .map((id) => Number(String(id).trim()))
              .filter((id) => !Number.isNaN(id))
          : [];
        let payload = {
          contractID: contractData.contract_id,
          vendor_id: contractData.vendor_id,
          movie_ids: contractData.movie_ids
            ? contractData.movie_ids.split(",").map(Number)
            : [],
          movie_names: contractData.title_for_rr
            ? contractData.title_for_rr.split("<br/>")
            : [],
          territory_names: contractData.territory
            ? contractData.territory.split(",")
            : [],
          territory_ids: selectedTerritoryIds.length
            ? selectedTerritoryIds
            : contractTerritoryIds,

          fromDate: this.filters.revenueDate
            ? this.filters.revenueDate.split("to")[0]
            : "",
          toDtae: this.filters.revenueDate
            ? this.filters.revenueDate.split("to")[1]
            : "",
        };
        const response = await GetRoyaltyReportDataTerritory(payload);
        if (response.data) {
          console.log(response.data.data, "response.data.data");
          this.royaltyReportData = response.data.data;
          this.royaltyReportData.showCoridorSection =
            this.royaltyReportData.showCoridorSection === true ||
            this.royaltyReportData?.totalColumn?.showRRCoridorSection === true;
          this.lastFetchedFilterSnapshot = { ...this.currentFilterSnapshot };
          this.hasFetchedTerritoryReport = true;
          this.reportDescription = this.royaltyReportData.reportDescription;
          if (!this.optionTempTerritory.length) {
            if (!isTerritoryFilterApplied && contractData.territory) {
              const contractTerritoryNames = String(contractData.territory)
                .split(",")
                .map((n) => String(n).trim())
                .filter(Boolean);
              for (let i = 0; i < contractTerritoryNames.length; i++) {
                this.optionTempTerritory.push({
                  ter: contractTerritoryNames[i],
                  id: contractTerritoryIds[i] ? contractTerritoryIds[i] : i,
                });
              }
            } else {
              let teriName =
                this.royaltyReportData.totalColumn.contractTerritories.split(
                  ",",
                );
              let teriId =
                this.royaltyReportData.totalColumn.territory_ids_array.split(
                  ",",
                );

              for (let i = 0; i < teriName.length; i++) {
                let p = teriName[i];

                this.optionTempTerritory.push({
                  ter: p,
                  id: teriId[i],
                });
              }
            }
          }

          if (!this.optionSearchTerritory.length) {
            let teriName =
              this.royaltyReportData.totalColumn.contractTerritories.split(",");
            let teriId =
              this.royaltyReportData.totalColumn.territory_ids_array.split(",");

            for (let i = 0; i < teriName.length; i++) {
              let p = teriName[i];

              this.optionSearchTerritory.push({
                ter: p,
                id: teriId[i],
              });
            }
          }
          this.loadFilterList();
          this.GetSavedReports();
        }
      } catch (err) {
        console.log("Error in getting  list ", err);
      }
    },
    showGenerateConfirm(data) {
      this.$bvModal
        .msgBoxConfirm(
          "Once royalty report gets generated it will get added to system logs!.Are you sure, you want to proceed with generate royalty report?",
          {
            title: "Confirmation",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: true,
            centered: true,
          },
        )
        .then((value) => {
          if (value === true) this.GenerateRoyaltyReportPdf(data);
        })
        .catch((err) => {
          // An error occurred
        });
    },
    resetForm() {
      (this.filters = {
        reportType: "territory",
        showReportBy: "vendor",
        reportView: "rights",
        licensor: null,
        movie: null,
        revenueDate: null,
      }),
        (this.reportContractId = null);
      this.selectedContractID = null;
      this.currentContractData = null;
      this.selectedRotaltyContracts = [];
      this.royaltyReportData = null;
      this.lastFetchedFilterSnapshot = null;
      this.hasFetchedTerritoryReport = false;
      this.GetSavedReports();
    },
    async handleMarkAsSent(item) {
      const confirmation = await this.showModal(
        `Are you sure you want to ${
          item.isReportSent == 0 ? "set " : "unset"
        } Report as Sent?`,
        "save",
      );

      if (confirmation) {
        this.updateFinalStatus(
          item.royalty_report_id,
          item.isFinalReport,
          item.isReportSent,
          "sent",
        );
      }
    },
    async handleMarkAsFinal(item) {
      const finalConfirmation = await this.showModal(
        `Are you sure you want to ${
          item.isFinalReport == 0 ? "set" : "unset"
        } report as final`,
        "save",
      );
      if (finalConfirmation) {
        this.updateFinalStatus(
          item.royalty_report_id,
          item.isFinalReport,
          item.isReportSent,
          "final",
        );
      }
    },
    showModal(text = "Are You Sure?", type = "save") {
      return this.$bvModal
        .msgBoxConfirm(text, {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: type == "save" ? "success" : "danger",
          cancelVariant: type == "save" ? "outline-success" : "outline-danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          return value;
        })
        .catch((err) => {
          console.log("error");
          return false;
        });
    },
    handleRevenueExpensesModalCancel() {
      this.showRevenueExpensesModal = false;

      // Refetch data for current contract
      if (this.currentContractData) {
        this.getRoyaltyReportMultiple(this.currentContractData);
      }
    },
    onChange() {
      this.$nextTick(() => {
        localStorage.setItem(
          "filtersAndPaginationGenerateRoyaltyReport",
          JSON.stringify({
            filters: this.filters,
            pagination: this.pagination,
          }),
        );
      });
    },
    loadFilterList() {
      const filtersAndPaginationGenerateRoyaltyReportStr = localStorage.getItem(
        "filtersAndPaginationGenerateRoyaltyReport",
      );
      if (filtersAndPaginationGenerateRoyaltyReportStr) {
        const obj = JSON.parse(filtersAndPaginationGenerateRoyaltyReportStr);
        this.filters = obj.filters;
        // this.$forceUpdate();
      }
    },
    getTableElement() {
      return (
        this.$refs.scrollableTable?.$el?.querySelector(".table-responsive") ||
        this.$refs.scrollableTable?.$el
      ); // checks if the tables exists and returns
    },
    updateScrollState() {
      const el = this.getTableElement();
      if (el) {
        // Force synchronous layout calculation
        void el.offsetHeight;

        this.maxScroll = el.scrollWidth - el.clientWidth; //how much space we have to scroll
        this.scrollPosition = el.scrollLeft; // current scroll position

        this.isAtRightEnd =
          this.maxScroll > 0 &&
          Math.abs(this.scrollPosition - this.maxScroll) < 1;

        // Only show buttons if we have valid measurements
        this.showScrollButtons = this.maxScroll > 10;

        // console.log('Scroll State:', {
        //   scrollPosition: this.scrollPosition,
        //   scrollWidth: el.scrollWidth,
        //   clientWidth: el.clientWidth,
        //   scrollLeft: el.scrollLeft,
        //   maxScroll: this.maxScroll,
        //   isAtRightEnd: this.isAtRightEnd,
        //   showButtons: this.showScrollButtons
        //   });
      } else {
        // Default safe values if element not found
        this.isAtRightEnd = false;
        this.showScrollButtons = false;
      }
    },
    handleScrollClick() {
      this.$root.$emit("bv::hide::tooltip"); // hide tooltip firstly
      const direction = this.isAtRightEnd ? "left" : "right";

      this.scrollTable(direction);
    },
    scrollTable(direction) {
      const el = this.getTableElement();
      if (el) {
        el.scrollLeft +=
          direction === "left" ? -el.scrollWidth : el.scrollWidth;
        this.updateScrollState();
      }
    },
    handleScroll() {
      this.updateScrollState();
    },
  },
  created() {},
  destroyed() {},
};
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/libs/vue-flatpicker.scss";
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td {
  white-space: nowrap;
}

td,
th {
  // border: 1px solid #000;
  text-align: left;
  padding: 5px;

  text-align: right;
}
.spacing {
  background-color: #eaecfd;
}
br {
  border: 1px solid #000;
}
table {
  font-family: verdana !important;
}
// smallWidth {
//   max-width: 100px !important;
// }
table {
  table-layout: fixed !important;
}
td {
  width: 33% !important;
}
.scroll-buttons {
  position: relative;
  display: flex;
  top: 50%;
  left: 0;
  right: 0;
  justify-content: space-between;
  pointer-events: none;
  transform: translateY(-50%);
  &.show {
    display: flex;
  }
}
.dynamic-scroll-button {
  transition: all 0.3s ease;
  width: 35px;
  height: 35px;
  position: relative;
  display: flex;
  pointer-events: auto;
  z-index: 10;
}
.dynamic-scroll-button:hover {
  transform: scale(1.1);
}
.scroll-button.left {
  margin-left: -20px;
}
.scroll-button.right {
  margin-right: -20px;
}
.scroll-button[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}
.table-responsive {
  scroll-behavior: smooth;
}
.force-wrap {
  white-space: normal !important;
}
.bg-gray-200 {
  background-color: #e5e7eb;
}
.report-table {
  width: 100%;
  color: #000;
  border: 1px solid #d9dde5;
  border-radius: 8px;
  overflow: hidden;
  font-variant-numeric: tabular-nums;
  table-layout: fixed;
}
.report-table col.col-label-main {
  width: 22%;
}
.report-table col.col-territory {
  width: 18%;
}
.report-table col.col-movie-unique {
  width: 18%;
}
.report-table col.col-num {
  width: 13.5%;
}
.report-table th,
.report-table td {
  padding: 6px 10px !important;
  font-size: 13px;
  line-height: 1.3;
  vertical-align: top;
}
.report-table thead th {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
  border-bottom: 1px solid #d1d5db;
}
.report-table tbody tr td {
  border-bottom: 1px solid #edf0f4;
}
.report-table tbody tr:last-child td {
  border-bottom: none;
}
.report-table .bg-gray-200 td,
.report-table .bg-gray-200 th {
  background-color: #e5e7eb;
}
.report-table .text-left {
  text-align: left !important;
}
.report-table .text-right {
  text-align: right !important;
}
.report-table .force-wrap {
  line-height: 1.4;
  word-break: break-word;
}
.report-table td.force-wrap > span {
  font-size: 10px;
  color: #4b5563;
  font-weight: 400;
}
.report-table .territory-unique-no {
  font-size: 10px;
  color: #374151;
  font-weight: 500;
}
.report-table .font-bold {
  font-weight: 700;
}
.report-table tbody tr.font-bold td,
.report-table tbody tr.bg-gray-200 td,
.report-table tbody tr.bg-gray-200 th {
  font-weight: 700 !important;
  color: #111827;
}
.report-table tbody tr.font-bold td {
  font-weight: 400 !important;
}
.report-table tbody tr.font-bold td:first-child {
  font-weight: 700 !important;
}
.report-table tbody tr:not(.font-bold):not(.bg-gray-200) td:first-child {
  font-weight: 500;
  color: #1f2937;
}
.report-table tr.pna-subheader td {
  background-color: #f3f4f6;
  border-top: 1px solid #d1d5db;
  border-bottom: none;
  font-weight: 600;
  color: #1f2937;
}
.report-table tr.pna-subheader td:first-child {
  font-weight: 700;
}
.report-table tr.pna-values td {
  background-color: #f3f4f6;
  border-top: none;
  border-bottom: 1px solid #d1d5db;
}
.report-table td,
.report-table th {
  text-align: right;
}
.report-table .text-left {
  text-align: left !important;
}
.report-table .text-right {
  text-align: right !important;
}
.report-table .text-center {
  text-align: center !important;
}
.report-table td,
.report-table th {
  font-variant-numeric: tabular-nums;
}
.font-bold {
  font-weight: 700;
}
.mb-8 {
  margin-bottom: 2rem;
}
.font-normal {
  font-weight: 400 !important;
}

.borderRadius-10 {
  & .vs__dropdown-toggle,
  .vue-treeselect__control {
    border-radius: 10px !important;
  }
  border-radius: 10px !important;
}

.buttonColor {
  background-color: #16dbcc !important;
  color: #000000 !important;
  border-color: #16dbcc !important;
  font-weight: 400 !important;
}

::v-deep .nav-pills .nav-link:not(.active) {
  color: #003b8e !important;
}

.left-pane-resizable {
  position: relative;
}
.pane-resizer {
  display: block;
  width: 8px;
  cursor: col-resize;
  background: linear-gradient(
    to right,
    rgba(148, 163, 184, 0.15),
    rgba(100, 116, 139, 0.25),
    rgba(148, 163, 184, 0.15)
  );
  border-radius: 6px;
  z-index: 10;
}
.pane-resizer-inline {
  position: absolute;
  top: 0;
  right: -4px;
  bottom: 0;
}
.pane-resizer:hover {
  background: linear-gradient(
    to right,
    rgba(99, 102, 241, 0.2),
    rgba(79, 70, 229, 0.35),
    rgba(99, 102, 241, 0.2)
  );
}
</style>
